import { Command } from 'commander'
import { createClient } from '../../../client.js'
import { handleError } from '../../../lib/errors.js'
import {
  isQuiet,
  printQuiet,
  printJson,
  printSuccess,
  printKeyValue,
} from '../../../output.js'

export const servicesCreateYjsCommand = new Command(`yjs`)
  .usage(`--environment <id> --name <name>`)
  .description(`Create a Yjs collaborative document service`)
  .requiredOption(`--environment <id>`, `Environment ID`)
  .requiredOption(`--name <name>`, `Service name`)
  .action(async (opts) => {
    const json =
      servicesCreateYjsCommand.parent?.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.services.yjs.create({
        environmentId: opts.environment,
        name: opts.name,
      })

      if (isQuiet()) {
        printQuiet(result.id)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printSuccess(`Service created successfully.\n`)
        printKeyValue([
          [`ID:`, result.id],
          [`Name:`, result.name],
          [`Base URL:`, result.baseUrl],
          [`Secret:`, result.secret],
        ])
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
